import React, { useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridSortModel,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import "./styles.scss";
import dayjs from "dayjs";
import { ChangeLogType } from "../../types/genericType";
import SearchField from "../common/Search/SearchField";
import "./styles.scss";
import { Box } from "@mui/material";

type ChangeLogTableProps = {
  data: Array<ChangeLogType>;
  search: string;
  clearSearch: Function;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ChangeLogTable = (props: ChangeLogTableProps) => {
  const { data, search, onSearchChange, clearSearch } = props;

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "date", sort: "desc" },
  ]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "date",
        headerName: "Time",
        minWidth: 210,
        sortable: true,
        valueFormatter: (params: GridValueFormatterParams) =>
          dayjs(params.value).format("MM/DD/YYYY hh:mm:ss A"),
        headerClassName: "header-datagrid",
      },
      {
        field: "modifiedBy",
        headerName: "User",
        minWidth: 180,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "operation",
        headerName: "Type",
        minWidth: 170,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "activity",
        headerName: "Activity",
        minWidth: 190,
        sortable: true,
        headerClassName: "header-datagrid",
      },
      {
        field: "client",
        headerName: "Client",
        minWidth: 180,
        sortable: true,
        headerClassName: "header-datagrid",
      },
      {
        field: "accountNumber",
        headerName: "Account #",
        minWidth: 120,
        sortable: true,
        headerClassName: "header-datagrid",
      },
      {
        field: "description",
        headerName: "Details",
        minWidth: 320,
        flex: 1,
        sortable: false,
        headerClassName: "header-datagrid",
      },
    ],
    []
  );

  return (
    <div className="data-table">
      <Box className="heading-row">
        <SearchField
          onSearchChange={onSearchChange}
          search={search}
          clearSearch={clearSearch}
        />
      </Box>
      <DataGrid
        rows={data}
        getRowId={(row) => row.id}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        className="datagrid"
      />
    </div>
  );
};

export default ChangeLogTable;
